<template>
  <div id="main" class="Bottoms">
    <div class="bt">
      <div class="btmain bmain">
        <img class="logo" src="@/common/images/bottom/logo2@3x.png" alt="" />
        <div class="ewm">
          <div class="ewmbox">
            <!-- <img src="@/common/images/bottom/gzh.png" alt="" />
            <img src="@/common/images/bottom/app.png" alt="" /> -->
          </div>
          <!-- <div class="ewmp">
            <span>官方微信公众号</span>
            <span>德讯证顾App</span>
          </div> -->
        </div>
        <!-- <div class="lxfsBox">

        </div> -->
        <div class="lxfs">
          <div>
            <!-- <span class="span0"><img src="@/common/images/bottom/14806.png" alt=""></span> -->
            <img src="@/common/images/bottom/14806.png" alt="" />
            <span class="span1">联系财富在线</span>
          </div>
          <div style="">
            <span class="yuan"></span>
            <span class="span0">投诉热线：</span>
            <span class="span1">0755-82298818</span>
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0">服务热线：</span>
            <span class="span1">400-636-8688</span>
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0">服务时间：</span>
            <span class="span2">工作日 9：00 - 18：30</span>
          </div>
        </div>
        <div class="lxfs" style="margin-right: ">
          <div>
            <!-- <span class="span0"><img src="@/common/images/bottom/14806.png" alt=""></span> -->
            <img src="@/common/images/bottom/14807.png" alt="" />
            <span class="span1">产品中心</span>
          </div>
          <div style="">
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('productCenter', 'bannera1')"
              >资讯金融</span
            >
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('productCenter', 'bannera2')"
              >数据金融</span
            >
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('productCenter', 'bannera3')"
              >教育金融</span
            >
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('productCenter', 'bannera4')"
              >投顾金融</span
            >
          </div>
        </div>
        <div class="lxfs">
          <div>
            <!-- <span class="span0"><img src="@/common/images/bottom/14806.png" alt=""></span> -->
            <img src="@/common/images/bottom/14812.png" alt="" />
            <span class="span1">关于财富在线</span>
          </div>
          <div style="">
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('about', 1)"
              >公司介绍</span
            >
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('about', 2)">公司信息</span>
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('about', 10)">相关声明</span>
          </div>
          <div>
            <span class="yuan"></span>
            <span class="span0" @click="tiaozhaung('about', 8)">诚聘英才</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bd">
      <div class="bdmain bmain">
        <!-- <div class="dnav">
          <ul v-for="(rou, index) in routers" :key="index">
            <li class="natitle">{{ rou.name }}</li>
            <li class="alink" v-for="(item, index2) in rou.rous" :key="index2"> -->
        <!-- <router-link :to="item.path">{{ item.name }}</router-link> -->
        <!-- <a
                @click="pathf(rou.path, item.path)"
                href="javaScript:void(0);"
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div> -->
        <!-- <div class="copyData">
          <div class="copyitem">
            <img src="@/common/images/bottom/dz.png" alt="" />
            <span
              >公司地址：广东省深圳市罗湖区笋岗街道田贝社区洪湖二街50号新南滨大厦3层</span
            >
          </div>
          <div class="copyitem">
            <img src="@/common/images/bottom/yx.png" alt="" />
            <span>企业邮箱：admin@dexunzhenggu.cn</span>
          </div>
          <div class="copyitem">
            <p>COPYRIGHT©2014深圳德讯证券顾问有限公司丨<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19014501号-6</a></p>
          </div>
        </div> -->
      </div>
      <div class="copyData">
        <div class="copyitem">
          <!-- <img src="@/common/images/bottom/dz.png" alt="" /> -->
          <span
            >公司地址：广东省深圳市罗湖区笋岗街道田贝社区洪湖二街50号新南滨大厦3层</span
          >
        </div>
        <div class="copyitem">
          <!-- <img src="@/common/images/bottom/yx.png" alt="" /> -->
          <span>企业邮箱：admin@dexunzhenggu.cn</span>
        </div>
        <div class="copyitem2">
          <!-- <p>COPYRIGHT©2014深圳德讯证券顾问有限公司丨<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19014501号-6</a></p> -->
          <p>
            COPYRIGHT©2014财富在线（深圳）科技有限公司丨
            <span>
                <img style="width:10px;height:10px;margin-right:2px;" src="../../assets/c42d0d3acfab49fea87c0dbc53728cb.png" alt=""><a href="https://beian.mps.gov.cn/#/query/webSearch" target="" style="text-decoration: none;margin-right:4px;">粤公网安备44030002004364号</a>
            </span>
            
            <a
              href="https://beian.miit.gov.cn/"
              target=""
              style="text-decoration: none"
              >粤ICP备19014501号-6</a>
          </p>
          <!-- <p style="text-align: left;padding-left: 108px;">成都市德讯数字传媒有限公司</p> -->
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottoms",
  data() {
    return {
      routers: [
        {
          name: "产品中心",
          rous: [
            {
              name: "大德周报",
              path: "/productCenter?index=1",
            },
            {
              name: "人工诊股",
              path: "/productCenter?index=2",
            },
            {
              name: "主题策略",
              path: "/productCenter?index=3",
            },
            {
              name: "大德精研",
              path: "/productCenter?index=4",
            },
            {
              name: "大德专属",
              path: "/productCenter?index=5",
            },
            {
              name: "数据产品",
              path: "/productCenter?index=6",
            },
          ],
          path: "productCenter",
        },
        {
          name: "投研风采",
          rous: [
            {
              name: "投顾团队",
              path: "/investTeam?index=1",
            },
            {
              name: "研究团队",
              path: "/investTeam?index=2",
            },
          ],
          path: "investTeam",
        },
        {
          name: "投资者教育",
          rous: [
            {
              name: "交易师名师团队",
              path: "/education?index=1",
            },
            {
              name: "建党百年专题投教",
              path: "/education?index=2",
            },
          ],
          path: "education",
        },
        {
          name: "资讯中心",
          rous: [
            {
              name: "德讯观市",
              path: "/information?index=1",
            },
            {
              name: "市场动态",
              path: "/information?index=2",
            },
          ],
          path: "information",
        },
        {
          name: "客服投诉",
          rous: [
            {
              name: "投资者保护渠道",
              path: "/investCenter?index=1",
            },
            {
              name: "投资者保护工作流程",
              path: "/investCenter?index=2",
            },
          ],
          path: "investCenter",
        },
        {
          name: "打非专栏",
          rous: [
            {
              name: "宣传文章",
              path: "/lawColumn",
            },
          ],
          path: "lawColumn",
        },
        {
          name: "关于德讯",
          rous: [
            {
              name: "公司简介",
              path: "/about?index=1",
            },
            {
              name: "企业文化",
              path: "/about?index=2",
            },
            {
              name: "公司资质",
              path: "/about?index=3",
            },
            {
              name: "党建专栏",
              path: "/about?index=4",
            },
            {
              name: "公司动态",
              path: "/about?index=5",
            },
            {
              name: "德财交易学堂",
              path: "/about?index=11",
            },
            {
              name: "人员公示",
              path: "/about?index=6",
            },
            {
              name: "支付公示",
              path: "/about?index=7",
            },
            {
              name: "诚聘英才",
              path: "/about?index=8",
            },
            {
              name: "联系我们",
              path: "/about?index=9",
            },
            {
              name: "相关声明",
              path: "/about?index=10",
            },
          ],
          path: "about",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    pathf(path_, path) {
      if (path_ == "about") {
        this.$router.push(path);
      } else if (path_ == "lawColumn") {
        this.$router.push(path);
      } else if (path_ == "investCenter") {
        this.$router.push(path);
      } else if (path_ == "information") {
        this.$router.push(path);
      } else if (path_ == "education") {
        this.$router.push(path);
      } else if (path_ == "investTeam") {
        this.$router.push(path);
      } else if (path_ == "productCenter") {
        this.$router.push(path);
      }
    },
    tiaozhaung(item, id) {
      //点击跳转链接
      if (item == "productCenter") {
        this.$emit("tiaozhaung", {name:item,id}); //子传父在当前产品页跳转
        this.$router.push({
          name: item,
          params: {
            id: id,
          },
        });
      }else{
        this.$router.push({ path: "/about?index=" + id,params:{id} });
        window.scrollTo(0, 0);
        window.location.reload();
        // this.$emit("tiaozhaung", {name:item,id}); //子传父在当前产品页跳转
      }
    },
  },
};
</script>
<style scoped>
.Bottoms {
    width: 100%;
    max-width: 1920px;
    overflow: hidden;
    z-index: 100;
    position: relative;
    margin: auto;
}
.bt,
.bd {
  width: 100%;
}
.bt {
  /* height: 231px; */
  overflow: hidden;
  background: rgba(42, 42, 42, 1);
  opacity: 1;
  padding-top: 27px;
  box-sizing: border-box;
}
.bd {
  overflow: hidden;
  /* background: rgba(102, 102, 102, 1); */
  background-color: #8c122e;
  opacity: 1;
}
.bmain {
  width: 1300px;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.bt .bmain {
  padding-left: 11px;
  box-sizing: border-box;
  margin-bottom: 24px;
}
.btmain {
  display: flex;
  justify-content: left;
}
.btmain .logo {
  width: 226px;
  height: 170px;
  margin: 3px 0 0 11px;
}
.btmain .ewm {
  width: 120px;
  height: 157px;
  margin-left: 72px;
  padding: 0 60px;
  box-sizing: border-box;
  border: 2px solid #404040;
  border-top: none;
  border-bottom: none;
  border-right: none;
  margin-top: 11px;
}
.ewmbox,
.ewmp {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: -1px;
}
.ewmp {
  margin-top: 10px;
}
.ewmp span {
  display: inline-block;
  width: 150px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #ffffff;
  opacity: 1;
  text-align: center;
}
.lxfs {
  margin-right: 123px;
}
.lxfs div {
  overflow: hidden;
  /* margin-bottom: 4px; */
  text-align: left;
  display: flex;
  align-items: center;
}
.lxfs div:nth-child(1) .span1 {
  /* font-weight: bold; */
  margin-top: 5px;
  font-size: 16px;
}
.lxfs .yuan {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: #fff;
  margin-right: 10px;
  margin-left: 19px;
}
.lxfs span,
.lxfs p {
  text-align: left;
  /* float: left; */
  display: inline-block;
}
.lxfs .span0 {
  height: 37px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 37px;
  color: #ffffff;
  /* opacity: 0.86; */
}
.lxfs .span0:hover {
  cursor: pointer;
}
.lxfs img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.lxfs .span1 {
  height: 37px;
  font-size: 14px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  line-height: 37px;
  color: #ffffff;
}
.lxfs .span2 {
  height: 37px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 37px;
  color: #ffffff;
  /* opacity: 0.86; */
}
.lxfs p {
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #ffffff;
  /* opacity: 0.65; */
}
.bdmain {
  /* background: #c27878; */
}
.dnav {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid #8f8f8f;
  padding-top: 20px;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
.copyData {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
  margin-bottom: 20px;
}
.copyitem {
  height: 17px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #ffffff;
}
.copyitem2{
  height: 17px;
  justify-content: left;
  align-items: center;
  color: #ffffff;
}
.copyitem2 p{
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 17px;
  color: #ffffff;
}
.copyitem2 a {
  color: #ffffff;

  text-decoration: underline;
}
.copyitem img {
  margin-right: 11px;
}
.copyitem span {
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 17px;
  color: #ffffff;
  /* opacity: 0.65; */
}
.copyitem p {
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 17px;
  color: #ffffff;
  /* opacity: 0.65; */
}
.copyitem a {
  color: #ffffff;

  text-decoration: underline;
}
.natitle {
  width: 100%;
  height: 22px;
  text-align: left;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #ffffff;
  opacity: 1;
  cursor: pointer;
}
.alink {
  margin-top: 16px;
}
.alink a {
  display: block;
  width: 100%;
  height: 20px;
  text-align: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #ffffff;
  opacity: 0.84;
  cursor: pointer;
}
.alink a:hover {
  color: #fe6b64;
}
</style>



// WEBPACK FOOTER //
// src/components/sub/Bottoms.vue